import SerialNoSettings from "./SerialNoSettings";

export default SerialNoSettings;